import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { homepageSections } from "@/mocks/comics";
import { getComicById } from "@/mocks/comics";

function StarRating({ rating }: { rating: number }) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;

  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-xs ${
            i < full
              ? "ri-star-fill text-accent-500"
              : i === full && hasHalf
              ? "ri-star-half-line text-accent-500"
              : "ri-star-line text-foreground-300"
          }`}
        ></i>
      ))}
    </div>
  );
}

export default function HotComics() {
  const hotIds = homepageSections.hotComics;
  const hotComics = hotIds.map((id) => getComicById(id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg mb-3 aspect-[5/7]">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full">
                      {comic.rating}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                    <span className="text-xs text-white/90">{comic.status}</span>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500">{comic.author}</p>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}